import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MemberFeeContractStatus } from '@enumerates/private';
import { MemberFeeContract } from '@models/index';
import { StringDto } from '@models/basic/string-dto';
import { EndpointParams } from '@models/utils/endpoint-params';

import { HttpService } from '@services/http.service';

// Contratos ya emitidos del socio: Historicos y detalles de suscripcion. No confundir con
// ContractsService ni ContractsFilterService, que son de reserva de servicios.
@Injectable({
    providedIn: 'root'
})
export class MemberContractService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    list(): Observable<MemberFeeContract[]> {
        return this.get('customer/contracts', this.defaultEndpointParams).pipe(map((response: any[]) => (response ?? []).map((item) => new MemberFeeContract().build(item))));
    }

    // Las tarifas que no exigen firma tambien emiten contrato (issued); al socio solo se le enseñan los firmados.
    listSigned(): Observable<MemberFeeContract[]> {
        return this.list().pipe(map((contracts) => contracts.filter((contract) => contract.status === MemberFeeContractStatus.signed)));
    }

    searchDocumentUrl(idMemberFee: string): Observable<string> {
        return this.get(`customer/contracts/${idMemberFee}/document`, this.defaultEndpointParams).pipe(map((response) => new StringDto().build(response).value));
    }

    send(idMemberFee: string): Observable<void> {
        return this.post(`customer/contracts/${idMemberFee}/send`, this.defaultEndpointParams, null, this.showSuccessMessage());
    }
}
